import { useMutation } from "react-query";
import {
  VehicleLicensePlateRequestParams,
  insertVehicleLicensePlate,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const insertVehicleLicensePlateFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: VehicleLicensePlateRequestParams;
}) => {
  return await insertVehicleLicensePlate(rowVersion, params);
};

export function useInsertVehicleLicensePlate() {
  return useMutation(insertVehicleLicensePlateFn, {
    mutationKey: MUTATION_KEYS.insertVehicleLicensePlate,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
